import React, { useEffect, useState } from 'react';
import JobsListing from '../../../components/jobs/JobsListing';
import { getUkBananaJobs } from '../../../services/HirecrapBanana';

const UkJobs = () => {
  const [list, setList]       = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const data = await getUkBananaJobs();
        setList(data.jobs);
      } catch (error) {
        console.log("Error fetching UK jobs:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchJobs();
  }, []);

  return (
    <div>
      <JobsListing
        title="Remote Jobs in United Kingdom"
        subTitle="Explore 100% remote job opportunities in the UK. Apply now for top remote roles on FetchJobs!"
        type="United Kingdom"
        searchKeyword=""
        suggestion={true}
        list={list}
        loading={loading}
        canonicalUrl="https://www.fetchjobs.co/remote-jobs-uk"
        countryCode="GB"
        metaTitle="Remote Jobs in UK – Work from Home Jobs | FetchJobs"
        metaDescription="Find high-paying remote jobs in the UK. Apply to verified work-from-home roles across IT, finance, marketing and more on FetchJobs."
      />
    </div>
  );
};

export default UkJobs;